<template>
  <div class="container">
    <el-container>
      <el-header>
        <head-bar></head-bar>
      </el-header>
      <el-container>
        <el-main>
          <content-list></content-list>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import HeadBar from "@/views/Layout/HeadBar";
import ContentList from "@/views/Content/List";
export default {
  components: {
    HeadBar,
    ContentList
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  min-width: 1200px;
  //background: rgba(224, 234, 235, 0.1);
  //background: rgb(236, 236, 236);
  //background: #bfbfbf;
  // background: rgb(222, 222, 222);

  .el-header {
    padding: 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Content/Index.vue